module.exports = __webpack_public_path__ + "img/graph_age.7f95a505.png";